import { render, staticRenderFns } from "./backDetail.vue?vue&type=template&id=67e91040&scoped=true&"
import script from "./backDetail.vue?vue&type=script&lang=js&"
export * from "./backDetail.vue?vue&type=script&lang=js&"
import style0 from "./backDetail.vue?vue&type=style&index=0&id=67e91040&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e91040",
  null
  
)

export default component.exports